import '@babel/polyfill';
//import './Areas/Common/Helpers/Namespace';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import DynamicIntlProvider from "./react-intl/dynamicIntlProvider";
import talentFormsStore from './TalentFormsStore';


// Render the app
ReactDOM.render(
  <Provider store={talentFormsStore}>
    <DynamicIntlProvider>
      <App />
    </DynamicIntlProvider>
  </Provider>,
  document.getElementById('TalentForms')
);